import { PropsWithChildren } from "react";
import { Box } from "@chakra-ui/react";
import { SkipNavContent } from "@chakra-ui/skip-nav";
import { Footer } from "src/components/layout/footer/footer";
import { Nav } from "src/components/layout/nav/nav";
import { LazyAudioPlayer } from "src/components-mui/common/audio-player/lazy-audio-player";
import { useIsCallerContentApp } from "src/lib/native-bridge/hooks/use-is-content-app";
import { IBasePageProps } from "src/types/layout";
import { Main } from "../base";
import { BannerSectionMemo } from "./banners/banner-section";
import { useNavHeight } from "./hooks/use-nav-height";
import { OverlayContainer } from "./overlay-container";
import SideButtons from "./side-buttons/side-buttons";

export const NAV_HEIGHT = [7, 8, 10];
export const MUI_NAV_HEIGHT = { xs: 56, sm: 64, md: 80 };

const DefaultLayout = (props: PropsWithChildren<IBasePageProps<unknown, unknown>>) => {
    const { navigation, user, footer, global, children } = props;

    const isCallerContentApp = useIsCallerContentApp();
    const { NAV_HEIGHT_VARIATION } = useNavHeight();
    const MAIN_PADDING_TOP = isCallerContentApp || !navigation ? 0 : NAV_HEIGHT_VARIATION;

    return (
        <Box display="flex" flexDir="column" minH="100vh">
            {navigation ? <Nav user={user} nav={navigation} height={NAV_HEIGHT} /> : null}
            <SkipNavContent />
            <Main pt={MAIN_PADDING_TOP} minH="70vh">
                {global && <BannerSectionMemo banners={global.banners} />}
                {children}
            </Main>
            {footer ? <Footer {...footer} /> : null}
            <SideButtons showServiceButtons={Boolean(global?.serviceButtons)} serviceButtonsLabels={global?.serviceButtons} />
            <OverlayContainer />
            <LazyAudioPlayer />
        </Box>
    );
};

export default DefaultLayout;
